import { render } from "./RecollectDashboardTable.vue?vue&type=template&id=453db4d1"
import script from "./RecollectDashboardTable.vue?vue&type=script&lang=js"
export * from "./RecollectDashboardTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__